import { PropsWithClassName } from "../../common/types/PropsWithClassName";

interface TicketTimeTrackingTotalTimeLabelProps extends PropsWithClassName {
  hours: number;
  minutes: number;
}

export default function TicketTimeTrackingTotalTimeLabel({ className, hours, minutes }: TicketTimeTrackingTotalTimeLabelProps) {
  return (
    <div className={`${className}`}>
      {hours > 0 ? `${hours} ${hours === 1 ? "ora" : "ore"}` : ""}
      {minutes > 0 ? `${hours > 0 ? " " : ""}${minutes} min` : ""}
    </div>
  );
}
